import { ref, computed, watch } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import { debounce } from "lodash"
import moment from "moment-timezone";
import store from "@/store";
import ability from "@/libs/acl/ability";
import useFilterCounter from '@/components/Filters/useFiltersCount'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default function useList(showFilters = true) {

  const refListTable = ref(null);
  const toast = useToast();

  store.dispatch('teams/getAll')
  const teamsOptions = computed(() => store.getters['teams/getSelectedItems'])
  const teamsFilter = ref(null)

  const tableColumns = [
    { label: "directory.name", key: "name", sortable: true },
    { label: "teams.title", key: "team.name", sortable: true },
    { label: "directory.position", key: "position", sortable: true },
    { label: "directory.phone1", key: "phone1", sortable: true },
    { label: "directory.phone2", key: "phone2", sortable: true },
    { label: "SOEID", key: "soeid", sortable: true },
    {
      label: "date.created_at",
      key: "created_at",
      sortable: true,
      formatter: "formatDateAssigned",
    },
    {
      label: "date.updated_at",
      key: "updated_at",
      sortable: true,
      formatter: "formatDateAssigned",
    },
  ];

  if (showFilters && (ability.can("update", "Directory") || ability.can("delete", "Directory"))) {
    tableColumns.splice(0, 0, { label: 'actions.name', key: 'actions' })
  }

  const perPage = ref(10);
  const totalList = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);
  const action = ref("list");

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    };
  });

  const fetchList = (ctx, callback) => {
    store
      .dispatch("directory/getAll", {
        q: searchQuery.value,
        max: perPage.value,
        "page[n]": currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        action: action.value,
        id_team: teamsFilter.value,
      })
      .then((response) => {
        if (action.value == "export") {
          action.value = "list";
        } else {
          callback(response.data);
          totalList.value = response.meta.total;
        }
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error obteniendo la información",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const formatDateAssigned = (value) => {
    const formattedDate = moment(value).format("DD/MM/YYYY HH:mm:ss");
    return formattedDate;
  };

  const refetchData = () => {
    refListTable.value.refresh();
  };

  watch([currentPage, perPage], () => {
    refetchData();
  });

  watch([searchQuery], debounce(() => {
    refetchData()
  }, 500))

  const filters = ref({});
  const filtersCount = useFilterCounter(filters);
  const buildFilters = () => {
    filters.value = {
      id_team: teamsFilter.value,
    };
    refetchData();
  }
  const clearSearchFilters = () => {
    teamsFilter.value = null;
    buildFilters();
  }

  return {
    tableColumns,
    perPage,
    currentPage,
    totalList,
    fetchList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,
    formatDateAssigned,
    refetchData,
    action,
    teamsOptions,
    teamsFilter,
    filtersCount,
    buildFilters,
    clearSearchFilters,
  };
}
